import { iCloudComputerTip } from '@/interface/cloud-computer-tip';
import request from '@/utils/request';

/* 创建版本号 */
export const postAddCloudComputerTip = (data: iCloudComputerTip): Promise<any> =>
  request({
    url: '/api/v1/omc/tips',
    method: 'put',
    data,
  });

/*  */
export const getCloudComputerTip = (): Promise<any> =>
  request({
    url: '/api/v1/omc/tips',
  });
